export const headcountEndpoints = {
  headcount: {
    config: '/reports/v1/headcount/config',
    employees: '/reports/v1/headcount/employees',
    hiringPlan: '/reports/v1/headcount/hiring_plan',
    assumptions: '/reports/v1/headcount/assumptions',
  },
}
